<script lang="ts">
    import Blob from '../../components/Blob.svelte';

    export const TOP_BLOB = [
        'M34.5,-64.2C43.7,-54.5,49.3,-43.1,58.9,-32.1C68.5,-21.2,81.9,-10.6,86.9,2.9C91.9,16.3,88.4,32.7,80.4,46.4C72.4,60,59.9,71.1,45.8,77.9C31.6,84.7,15.8,87.3,0.4,86.6C-15.1,86,-30.1,82.1,-41,73.4C-51.9,64.7,-58.6,51.2,-64.5,38.2C-70.4,25.2,-75.4,12.6,-78.3,-1.7C-81.2,-15.9,-82,-31.8,-73.9,-41.2C-65.9,-50.5,-49.1,-53.3,-35.4,-60.2C-21.6,-67.2,-10.8,-78.3,1,-80C12.7,-81.6,25.4,-73.8,34.5,-64.2Z',
        'M37.5,-68.8C46.9,-59.5,51.7,-46.1,55.4,-33.9C59.1,-21.8,61.6,-10.9,65.4,2.2C69.2,15.3,74.2,30.5,69.4,40.7C64.6,50.9,49.9,56,36.7,62.5C23.5,69.1,11.8,77.1,0.1,76.9C-11.6,76.7,-23.1,68.4,-33.4,60.1C-43.6,51.9,-52.5,43.7,-59.1,33.7C-65.6,23.7,-69.7,11.8,-69.5,0.1C-69.2,-11.5,-64.6,-23.1,-59.9,-36.2C-55.2,-49.4,-50.3,-64.1,-40.3,-73C-30.3,-81.9,-15.2,-85.1,-0.6,-84.1C14,-83.1,28.1,-78,37.5,-68.8Z',
        'M35.3,-60.9C47.8,-54,61.3,-48.6,68.5,-38.7C75.7,-28.8,76.7,-14.4,76.2,-0.3C75.7,13.8,73.7,27.6,68.1,40.4C62.6,53.2,53.5,65.1,41.6,69.4C29.6,73.7,14.8,70.4,-0.8,71.7C-16.4,73.1,-32.8,79.1,-46.9,76.1C-61,73,-72.9,61,-80.6,46.8C-88.4,32.6,-92.1,16.3,-91.9,0.1C-91.6,-16.1,-87.5,-32.1,-78.7,-44.4C-69.8,-56.7,-56.2,-65.3,-42.3,-71.4C-28.4,-77.5,-14.2,-81.1,-1.4,-78.7C11.4,-76.3,22.9,-67.9,35.3,-60.9Z',
    ];

    export const BOT_BLOB = [
        'M41.7,-72.2C53.8,-65.2,63.2,-53.6,66.9,-40.8C70.7,-28,68.7,-14,69.8,0.7C71,15.3,75.3,30.6,72.2,44.6C69.1,58.5,58.7,71.1,45.5,79.5C32.2,87.9,16.1,92.1,1.3,89.9C-13.6,87.8,-27.2,79.2,-37.1,68.9C-47,58.6,-53.2,46.4,-61.8,34.6C-70.4,22.8,-81.5,11.4,-85.6,-2.4C-89.7,-16.2,-86.8,-32.3,-78.6,-44.8C-70.4,-57.2,-56.8,-66,-42.8,-71.9C-28.8,-77.9,-14.4,-81.1,0.2,-81.4C14.8,-81.8,29.6,-79.3,41.7,-72.2Z',
        'M34.3,-60C45.8,-52.8,57.3,-46.3,67.4,-36.4C77.5,-26.5,86.2,-13.2,86.3,0C86.3,13.3,77.7,26.6,69.6,39.9C61.4,53.2,53.7,66.5,42.2,76.4C30.7,86.4,15.4,93,2,89.4C-11.3,85.9,-22.5,72.2,-35.6,63.2C-48.7,54.1,-63.7,49.8,-74.6,40C-85.5,30.3,-92.5,15.1,-91.1,0.8C-89.7,-13.5,-79.9,-27,-69.5,-37.7C-59.1,-48.4,-48.1,-56.3,-36.4,-63.3C-24.7,-70.4,-12.3,-76.7,-0.5,-75.8C11.4,-75,22.8,-67.2,34.3,-60Z',
        'M32.7,-59.9C43.3,-50.6,53.3,-43.6,59.5,-34C65.6,-24.4,68,-12.2,70.7,1.6C73.5,15.4,76.6,30.7,70.4,40.2C64.2,49.7,48.6,53.4,35.3,59.2C22,65,11,72.9,-0.3,73.5C-11.7,74.1,-23.3,67.3,-37.7,62.1C-52,56.9,-69.1,53.3,-76.7,43.2C-84.4,33.1,-82.6,16.6,-77.8,2.8C-72.9,-11,-65,-22,-59.6,-35.9C-54.1,-49.8,-51.1,-66.6,-41.6,-76.4C-32.1,-86.3,-16.1,-89.2,-2.5,-84.9C11.1,-80.6,22.2,-69.1,32.7,-59.9Z',
    ];
</script>

<div class="blob top">
    <Blob ds={TOP_BLOB} duration="20s" />
</div>
<div class="blob bot">
    <Blob ds={BOT_BLOB} duration="28s" />
</div>

<style>
    .blob {
        @apply text-blue-300;
        @apply fixed z-[-999];
        @apply w-[100cqh];
    }

    .top {
        @apply left-[-60cqh] top-[-30cqh];
    }

    .bot {
        @apply bottom-[-30cqh] right-[-60cqh];
    }
</style>
